import React from 'react';
import times from 'lodash/times';
import { DataReconciliationTableHeader } from './components/DataReconciliationTableHeader';
import {
  TableBody,
  TableCell,
  TableRow,
  TableWrapper,
} from '../../CommonComponents/OPL/Table/Table';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';

interface Props {}

export const DataReconciliationTableLoading: React.FC<Props> = () => {
  return (
    <TableWrapper variant="noTitle">
      <DataReconciliationTableHeader />

      <TableBody>
        {times(4).map(i => (
          <TableRow key={i}>
            <TableCell>
              <Shimmer height="16px" width="200px" />
            </TableCell>
            <TableCell minWidth={200} flex="0 1 auto">
              <Shimmer height="16px" width="100px" />
            </TableCell>
            <TableCell minWidth={160} flex="0 1 auto">
              <Shimmer height="16px" width="75px" />
            </TableCell>
            <TableCell width={48} justifyContent="center" flex="0 1 auto">
              <Shimmer height="16px" width="16px" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TableWrapper>
  );
};
